import type { ReactElement, ReactNode } from 'react'

import { Hoverable } from './Hoverable'
import type { HoverPlacement, HoverSpeed } from './hoverTypes'

interface TipProps {
  label: string
  shortcut?: string
  placement?: HoverPlacement
  group?: string
  disabled?: boolean
  offset?: number
  /** Defaults to `immediate` — Tip is meant for icon buttons where the tooltip
   * IS the label. Pass `delayed` for text tips (e.g. overflow disclosure) where
   * the visible content already tells the user what it is. */
  speed?: HoverSpeed
  children: ReactElement<Record<string, unknown>> | ReactNode
}

/**
 * Shorthand for `<Hoverable variant="label" content={{title: label}}>`.
 * Use for icon buttons and toolbar controls that would otherwise carry a bare
 * `title="…"` attribute.
 */
export function Tip({ label, shortcut, placement = 'top', group, disabled, offset, speed = 'immediate', children }: TipProps) {
  return (
    <Hoverable
      variant="label"
      placement={placement}
      group={group}
      disabled={disabled}
      offset={offset}
      speed={speed}
      content={{ title: label, shortcut }}
    >
      {children}
    </Hoverable>
  )
}
